import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import PrintHeader from "../General/PrintHeader";
import { toast, ToastContainer } from "react-toastify";
import user from "../../assets/images/user.png";

import Page from "../General/Page";

const CHALLAN_LIMIT = 24;

const PrintStudentProfile = () => {
  document.title = "Print Student Profile";

  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [loading, setLoading] = useState(true);

  const [listOfChallans, setListOfChallans] = useState([]);
  const [challansLoading, setChallansLoading] = useState(false);

  const [Student, setStudent] = useState({});

  const [AttendenceList, setAttendenceList] = useState([]);
  const [History, setHistory] = useState([]);

  const urlParams = new URLSearchParams(window.location.search);
  const StudentCode = urlParams.get("StudentCode");

  useEffect(() => {
    if (!StudentCode) {
      setLoading(false);
      toast.error("Missing StudentCode in URL.", { position: toast.POSITION.TOP_RIGHT });
      return;
    }

    setLoading(true);
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      Registration_No: StudentCode,
    };

    axios({
      method: "post",
      url: config.base_url + "Student/GetStudentByRegistrationNo",
      headers: { "Content-Type": "application/json" },
      data,
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          setStudent(response.data.Student || {});
        } else {
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setStudent({});
        }
      })
      .catch(function () {
        toast.error("Network Error..", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setStudent({});
      })
      .finally(() => {
        setLoading(false);
      });
  }, [StudentCode, AccessKey, UserID, MemberType]);

  useEffect(() => {
    const sid = Student?.Student_ID;
    if (!sid) {
      setListOfChallans([]);
      setAttendenceList([]);
      setHistory([]);
      return;
    }

    const base = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      Student_ID: sid,
    };

    setChallansLoading(true);
    axios({
      method: "post",
      url: config.base_url + "Student/GetChallansForStudent",
      headers: { "Content-Type": "application/json" },
      data: {
        ...base,
        Registration_No: Student?.Registration_No || "",
      },
    })
      .then((res) => {
        if (res.data.status_code === 1) {
          const rows = res.data.ListofRecords || [];
          setListOfChallans(rows.slice(0, CHALLAN_LIMIT));
        } else {
          setListOfChallans([]);
        }
      })
      .catch(() => setListOfChallans([]))
      .finally(() => setChallansLoading(false));

    axios({
      method: "post",
      url: config.base_url + "StudentAttendance/GetAttendanceByStudentID",
      headers: { "Content-Type": "application/json" },
      data: { UserID: UserID, AccessKey: AccessKey, Student_ID: sid },
    })
      .then((res) => {
        if (res.data.status_code === 1) {
          setAttendenceList(res.data.ListofRecords || []);
        } else {
          setAttendenceList([]);
        }
      })
      .catch(() => setAttendenceList([]));

    axios({
      method: "post",
      url: config.base_url + "Student/GetStudentByID",
      headers: { "Content-Type": "application/json" },
      data: { ...base, ID: sid },
    })
      .then((res) => {
        if (res.data.status_code === 1) {
          setHistory(res.data.ListofStatusHistory || []);
        } else {
          setHistory([]);
        }
      })
      .catch(() => setHistory([]));
  }, [Student?.Student_ID, AccessKey, UserID, MemberType, Student?.Registration_No]);

  const formatMoney = (v) => {
    const n = typeof v === "number" ? v : parseFloat(String(v ?? "").replace(/,/g, ""));
    if (!Number.isFinite(n)) return "—";
    return n.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  };

  const challanAmount = (item) => {
    if (item == null) return null;
    const due = item.Due_Date_Amount;
    const after = item.After_Due_Date_Amount;
    if (due != null && due !== "") return due;
    if (after != null && after !== "") return after;
    return null;
  };

  const renderChallans = () => {
    if (challansLoading) {
      return (
        <tr>
          <td className="text-center" colSpan="7">
            <Spinner animation="border" role="status" size="sm" />
          </td>
        </tr>
      );
    }
    if (listOfChallans != null && listOfChallans.length > 0) {
      return listOfChallans.map((item, index) => {
        const paid = item.Is_Paid === true || item.Is_Paid === "true" || item.Is_Paid === 1;
        const amt = challanAmount(item);
        return (
          <tr key={item.Challan_No || index}>
            <td>{index + 1}</td>
            <td>{item.Challan_No ?? ""}</td>
            <td>
              {item.Month ?? "—"}/{item.Year ?? "—"}
            </td>
            <td>{item.Dated && moment(item.Dated).isValid() ? moment(item.Dated).format("DD/MM/YYYY") : "—"}</td>
            <td>{item.Due_Date && moment(item.Due_Date).isValid() ? moment(item.Due_Date).format("DD/MM/YYYY") : "—"}</td>
            <td className="text-end">{amt != null && amt !== "" ? formatMoney(amt) : "—"}</td>
            <td className="text-center">{paid ? "Paid" : "Unpaid"}</td>
          </tr>
        );
      });
    }
    return (
      <tr>
        <td colSpan="7">
          <h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>
            No challans found.
          </h4>
        </td>
      </tr>
    );
  };

  const paidCount = listOfChallans.filter(
    (c) => c.Is_Paid === true || c.Is_Paid === "true" || c.Is_Paid === 1
  ).length;
  const unpaidCount = listOfChallans.length - paidCount;

  return (
    <>
      <ToastContainer />
      <Page orientation="portrait" size="a4">
        {loading ? (
          <div className="text-center p-4">
            <Spinner animation="border" role="status" />
          </div>
        ) : (
          <table className="table table-sm table-bordered table-print white-space-wrap">
            <thead>
              <tr>
                <th colSpan={20}>
                  <PrintHeader />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ border: "transparent" }}>
                <td style={{ width: "75%" }}>
                  <div>
                    <h6 className="">
                      <b>Registration Details</b>
                    </h6>
                    <table>
                      <tbody>
                        <tr>
                          <td style={{ width: "150px" }}>Form No</td>
                          <td style={{ width: "10px" }}>:</td>
                          <td>{Student.Form_No ?? ""}</td>
                        </tr>
                        <tr>
                          <td>Registration No</td>
                          <td>:</td>
                          <td>{Student.Registration_No ?? ""}</td>
                        </tr>
                        <tr>
                          <td>Student ID</td>
                          <td>:</td>
                          <td>{Student.Student_ID ?? ""}</td>
                        </tr>
                        <tr>
                          <td>Bay Form No</td>
                          <td>:</td>
                          <td>{Student.Bay_Form_No ?? ""}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
                <td align="right" valign="top">
                  <img src={user} alt="" />
                </td>
              </tr>
              <tr style={{ border: "transparent" }}>
                <td style={{ width: "75%" }}>
                  <div>
                    <h6 className="">
                      <b>Basic Information</b>
                    </h6>
                    <table>
                      <tbody>
                        <tr>
                          <td style={{ width: "150px" }}>Student Name</td>
                          <td style={{ width: "10px" }}>:</td>
                          <td>{Student.Student_Name ?? ""}</td>
                        </tr>
                        <tr>
                          <td>Father Name</td>
                          <td>:</td>
                          <td>{Student.Father_Name ?? ""}</td>
                        </tr>
                        <tr>
                          <td>Father CNIC No</td>
                          <td>:</td>
                          <td>{Student.Father_CNIC ?? ""}</td>
                        </tr>
                        <tr>
                          <td>Mother CNIC No</td>
                          <td>:</td>
                          <td>{Student.Mother_CNIC ?? ""}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <td>Gender</td>
                        <td>:</td>
                        <td>{Student.Gender === true || Student.Gender === "true" ? "Male" : Student.Gender === false || Student.Gender === "false" ? "Female" : "—"}</td>
                      </tr>
                      <tr>
                        <td>Date of Birth</td>
                        <td>:</td>
                        <td>
                          {Student.Date_Of_Birth && moment(Student.Date_Of_Birth).isValid()
                            ? moment(Student.Date_Of_Birth).format("DD/MM/YYYY")
                            : "—"}
                        </td>
                      </tr>
                      <tr>
                        <td>Group</td>
                        <td>:</td>
                        <td>{Student?.SelectedGroup?.Group_Name ?? "—"}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr style={{ border: "transparent" }}>
                <td colSpan={2}>
                  <h6 className="">
                    <b>Contact Details</b>
                  </h6>
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td style={{ width: "150px" }}>Temporary Address</td>
                        <td style={{ width: "10px" }}>:</td>
                        <td>{Student.Temporary_Address ?? ""}</td>
                      </tr>
                      <tr>
                        <td>Permanent Residence</td>
                        <td>:</td>
                        <td>{Student.Permanent_Address ?? ""}</td>
                      </tr>
                      <tr>
                        <td>Contact Phone</td>
                        <td>:</td>
                        <td>{Student.Contact_Phone ?? ""}</td>
                      </tr>
                      <tr>
                        <td>Mobile</td>
                        <td>:</td>
                        <td>{Student.Contact_Mobile ?? ""}</td>
                      </tr>
                      <tr>
                        <td>Email Address</td>
                        <td>:</td>
                        <td>{Student.Contact_Email ?? ""}</td>
                      </tr>
                      <tr>
                        <td>Class Details</td>
                        <td>:</td>
                        <td>{Student?.SelectedClass?.Class_Name ?? "—"}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr style={{ border: "transparent" }}>
                <td colSpan={2}>
                  <h6 className="">
                    <b>Facilities Taking</b>
                  </h6>
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td style={{ width: "150px" }}>Transport Facility</td>
                        <td style={{ width: "10px" }}>:</td>
                        <td>{Student?.SelectedRoot?.Root_Name ?? "—"}</td>
                      </tr>
                      <tr>
                        <td>Concession Rule</td>
                        <td>:</td>
                        <td>{Student?.SelectedConcessionRule?.Concession_Rule_Name ?? "—"}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr style={{ border: "transparent" }}>
                <td colSpan={2}>
                  <h6 className="">
                    <b>Other Information</b>
                  </h6>
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td style={{ width: "150px" }}>Prev. School Info</td>
                        <td style={{ width: "10px" }}>:</td>
                        <td>{Student.Previous_School_Info ?? ""}</td>
                      </tr>
                      <tr>
                        <td>NOC Board</td>
                        <td>:</td>
                        <td>{Student.NOC_Board ?? ""}</td>
                      </tr>
                      <tr>
                        <td>Remarks</td>
                        <td>:</td>
                        <td>{Student.Remarks ?? ""}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr style={{ border: "transparent" }}>
                <td colSpan={2}>
                  <h6 className="">
                    <b>Fee challans (latest)</b>
                  </h6>
                  <p className="small text-muted mb-1" style={{ marginTop: 0 }}>
                    Showing up to {CHALLAN_LIMIT} most recent fee challans and payment status (same data as student fee ledger).
                  </p>
                  <table className="table table-sm table-bordered table-print white-space-wrap">
                    <thead>
                      <tr>
                        <th>Sr.#</th>
                        <th>Challan No.</th>
                        <th>Month / Year</th>
                        <th>Issue date</th>
                        <th>Due date</th>
                        <th>Amount</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {renderChallans()}
                      {!challansLoading && listOfChallans != null && listOfChallans.length > 0 && (
                        <tr>
                          <th colSpan={6} className="text-end">
                            Summary (this list): Paid {paidCount} · Unpaid {unpaidCount}
                          </th>
                          <th />
                        </tr>
                      )}
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr style={{ border: "transparent" }}>
                <td colSpan={2}>
                  <h6 className="">
                    <b>Attendence</b>
                  </h6>
                  <table className="table table-sm table-bordered table-print white-space-wrap">
                    <thead>
                      <tr>
                        <th>Student ID</th>
                        <th>Student Name</th>
                        <th>Class Name</th>
                        <th>Registration NO</th>
                        <th>Absent Level</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(AttendenceList || []).length === 0 ? (
                        <tr>
                          <td colSpan="5" className="text-center text-muted">
                            No attendance records.
                          </td>
                        </tr>
                      ) : (
                        AttendenceList.map((item, index) => (
                          <tr key={`att-${item.Student_ID}-${index}`}>
                            <td>{item.Student_ID}</td>
                            <td>{item.Student_Name}</td>
                            <td>{item.Class_Name}</td>
                            <td>{item.Registration_No}</td>
                            <td>{item.Absent_Leave}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr style={{ border: "transparent" }}>
                <td colSpan={2}>
                  <h6 className="">
                    <b>History</b>
                  </h6>
                  <table className="table table-sm table-bordered table-print white-space-wrap">
                    <thead>
                      <tr>
                        <th>Serial No</th>
                        <th>Student Name</th>
                        <th>Status Detail</th>
                        <th>Dated</th>
                        <th>Modified By</th>
                        <th>REMARKS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(History || []).length === 0 ? (
                        <tr>
                          <td colSpan="6" className="text-center text-muted">
                            No history records.
                          </td>
                        </tr>
                      ) : (
                        History.map((item, index) => (
                          <tr key={`hist-${index}`}>
                            <td>{index + 1}</td>
                            <td>{item.Student_Name}</td>
                            <td>{item.Status_Type_Name}</td>
                            <td>{item.Dated && moment(item.Dated).isValid() ? moment(item.Dated).format("DD/MM/YYYY") : "—"}</td>
                            <td>{item.Modified_By}</td>
                            <td>{item.Remarks}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </Page>
    </>
  );
};

export default PrintStudentProfile;
